import { ModalProps } from '@/interfaces/common.interface';
import { svgIcons } from '../../UI/SvgIcons';

const { CrossIcon } = svgIcons;

const Model: React.FC<ModalProps> = ({
  title,
  show,
  size = 'w-[500px]',
  onClose,
  children,
  height = 'max-h-80',
  className = ''
}) => {
  if (!show) return null;

  return (
    <div
      onClick={() => onClose()}
      className="w-full h-screen fixed inset-0 bg-black/50 z-50">
      <div
        onClick={(e) => { e.stopPropagation() }}
        className={`${size} ${height} h-full rounded-xl top-20 absolute left-1/2 -translate-x-1/2 bg-white ${className}`}
      >
        <div className="h-full flex flex-col  drop-shadow-xl z-20 w-full min-h-full p-4 rounded-md">
          <div className="mb-6 relative flex items-center justify-between">
            <h2 className="text-xl font-medium">{title}</h2>
            <div className="flex gap-1">
              <button
                type="button"
                onClick={() => onClose()}
                className="button__ico uk-modal-close p-1"
              >
                <span>{CrossIcon}</span>
              </button>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Model;
